export default __webpack_public_path__ + "static/media/3.a1a2bc12.jpg";